const CAPTCHA_SCRIPT_URL =
  'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=onCaptchaLoaded';

declare global {
  interface Window {
    onCaptchaLoaded?: () => void;
  }
}

class YandexCaptchaService {
  loadScript(): Promise<void> {
    if ((window as { smartCaptcha?: unknown }).smartCaptcha) {
      return Promise.resolve();
    }

    return new Promise(resolve => {
      window.onCaptchaLoaded = () => resolve();

      const head = document.getElementsByTagName('head')[0];
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src = CAPTCHA_SCRIPT_URL;
      head.appendChild(script);
    });
  }
}

export { YandexCaptchaService };
